import styled from 'styled-components';
import { Form, Input } from 'antd';

export const FormItemWith50 = styled(Form.Item)`
  width: 50%;
`;

export const FormItemWith40 = styled(Form.Item)`
  width: 40%;
`;

export const FormItemWith30 = styled(Form.Item)`
  width: 30%;
`;

export const InlineContainer = styled.div`
  display: flex;
  .ant-form-item:not(:first-child) {
    margin-left: 16px;
  }
`;

export const StyldAnchor = styled.a`
  font-size: 12px;
  color: #21b4b;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  button {
    margin-right: 16px;
  }
`;

export const WeightageInput = styled(Input)`
  width: 120px;
  color: rgba(0, 0, 0, 0.65) !important;
`;

export const LabelContainer = styled.div`
  margin-left: 8px;
  margin-top: 30px;
  span:first-child {
    margin-right: 16px;
  }
`;

export const StyledLabel = styled.span`
  background-color: #eef4fa;
  color: #2b73e0;
  padding: 6px 8px;
  border-radius: 16px;
  font-size: 12px;
  cursor: pointer;
`;
